var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{class:`view`},[_c('transition',{attrs:{"name":"fade"}},[(_vm.$store.getters.showDimmer)?_c('div',{staticClass:"dimmer"}):_vm._e()]),_c('router-view')],1),_c('modals-container')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }